/** @format */

import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from "react-router";
import { Container, Row, Col } from "react-bootstrap";

import { singleService, homeUBT } from "../../../Features/HomeApi/HomeSlice";
import { allSets } from "../../../Features/SetsAPI/SetsSlice";
import { openModal, openLoginForm } from "../../../Features/ViewSlice";

import SEO from "../Seo/Seo";
import PageHeadings from "../PageHeadings";
import Loader from "../Loader/Loader";
import SetsItem from "../../DashboardView/Components/SetsItem";

const ModuleUBT = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedService = useSelector(
    (state) => state.home.selectedSingleService,
    shallowEqual,
  );

  const seoData = selectedService?.seo_data;

  const ubtItems = useSelector((state) => state.home.homeModule);
  const allSetslist = useSelector((state) => state.set.allSets);
  const token = useSelector((state) => state.auth?.currentUser?.token);
  const isLoading = useSelector((state) => state.home.homeModuleLoading);

  useEffect(() => {
    dispatch(singleService({ id: 1 }));
    token ? dispatch(allSets(token)) : dispatch(homeUBT());
  }, [dispatch, token]);

  const loginModel = () => {
    if (!token) {
      dispatch(openModal("loginView"));
      dispatch(openLoginForm());
    } else {
      navigate("/dashboard/ubt-test", { replace: true });
    }
  };

  if (isLoading) {
    return (
      <div className="loading__mode bigLoading">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {/* 🔥 SEO maintained strictly from API */}
      {seoData && (
        <SEO
          title={seoData.meta_title}
          description={seoData.meta_description}
          keywords={seoData.meta_keywords?.join(", ")}
          path={seoData.canonical_url}
        />
      )}

      <PageHeadings item={selectedService} hasIcon />

      <Container>
        <div className="services-lists">
          <Row className="setstitem-container">
            {!token &&
              ubtItems?.slice(0, 6).map((item, i) => (
                <Col md={6} key={i}>
                  <SetsItem
                    details={item}
                    type="home"
                    handleClick={loginModel}
                  />
                </Col>
              ))}

            {token &&
              allSetslist?.slice(0, 6).map((item, i) => (
                <Col md={6} key={i}>
                  <SetsItem details={item} />
                </Col>
              ))}
          </Row>

          <div className="text-center" onClick={loginModel}>
            <button className="btn">Explore More UBT Tests</button>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ModuleUBT;
